import Vue from 'vue'
import consts from '@/consts'
import { createActionHelpers } from 'vuex-loading'
import i18n from '@/translator'

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})

const initialStates = function () {
  return {
    ppPlans: null
  }
}

const mutations = {
  logout (state) {
    let init = initialStates()
    Object.keys(init).forEach((key) => {
      state[key] = init[key]
    })
  },
  setPPplans (state, value) {
    state.ppPlans = value
  }
}

const actions = {
  getBanners ({commit, dispatch}, value) {
    startLoading(dispatch, 'home getBanners')
    return new Promise((resolve, reject) => {
      Vue.http.get(consts.API_BASE_URL + '/getBanners').then(
        function (response) {
          endLoading(dispatch, 'home getBanners')
          if (response.body.status) {
            resolve(response.body.banners)
          } else {
            reject(new Error(response.body.error.message))
          }
        },
        function () {
          endLoading(dispatch, 'home getBanners')
          reject(new Error('Error de red'))
        })
    })
  },
  getProviders ({commit, dispatch}, data) {
    startLoading(dispatch, 'getProviders')
    return Vue.http.get(consts.API_BASE_URL + '/getProviderByCountry?provider=' + data.provider + '&country=' + data.providerCountry).then(
      function (response) {
        endLoading(dispatch, 'getProviders')
        if (response.body.status) {
          commit('setIlProviders', response.body.data)
          localStorage.setItem('provider_msj', response.body.data.unsuscribe_message)
          localStorage.setItem('provider_n', response.body.data.number)
          localStorage.setItem('provider_email', response.body.data.email)
        } else {
          commit('error', {error: true, message: i18n.t('error.store.network')})
          return Promise.reject(new Error(i18n.t('error.store.network')))
        }
      },
      function () {
        endLoading(dispatch, 'getProviders')
        commit('error', {error: true, message: i18n.t('error.store.network')})
        return Promise.reject(new Error(i18n.t('error.store.network')))
      })
  },
  getPPplans ({commit, dispatch}) {
    startLoading(dispatch, 'getPPplans')
    return Vue.http.get(consts.API_BASE_URL + '/payment/pp/getPlans').then(
      function (response) {
        endLoading(dispatch, 'getPPplans')
        if (response.body.status) {
          commit('setPPplans', response.body.data.plans)
          return response.body.data.plans
        } else {
          commit('error', {error: true, message: i18n.t('error.store.network')})
          return Promise.reject(new Error(i18n.t('error.store.network')))
        }
      },
      function () {
        endLoading(dispatch, 'getPPplans')
        commit('error', {error: true, message: i18n.t('error.store.network')})
        return Promise.reject(new Error(i18n.t('error.store.network')))
      })
  },
  getLocalRadios ({commit, dispatch}, country) {
    startLoading(dispatch, 'getLocalRadios')
    return new Promise((resolve, reject) => {
      Vue.http.get(consts.API_BASE_URL + '/getLocalRadios?country=' + country).then(
        function (response) {
          endLoading(dispatch, 'getLocalRadios')
          if (response.body.status) {
            resolve(response.body.data)
          } else {
            reject(new Error(response.body.error.message))
          }
        },
        function () {
          endLoading(dispatch, 'getLocalRadios')
          reject(new Error('Error de red'))
        })
    })
  }
}

const getters = {
  ppPlans: state => {
    return state.ppPlans
  }
}

const home = {
  namespaced: true,
  initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
}

export default home



// WEBPACK FOOTER //
// ./src/store/modules/home.js